import { applyMiddleware, combineReducers, createStore, Middleware, Reducer } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import { createLogger } from 'redux-logger'
import createSagaMiddleware from 'redux-saga'
// @ts-ignore todo @steve please fix this
import { createBrowserHistory, History } from 'history'
import { createReduxHistoryContext } from 'redux-first-history'

import { rootReducer, RootState } from '~store/root.reducer'
import { rootSaga } from '~store/root.sagas'
import { isDebugEnv } from '~config/envConfig'

interface CombinedReducerState extends RootState {
  router: Reducer
}

const logger = createLogger({ collapsed: true })
const sagaMiddleware = createSagaMiddleware()

const { createReduxHistory, routerMiddleware, routerReducer } = createReduxHistoryContext({
  history: createBrowserHistory(),
})

const middleware: Middleware[] = [sagaMiddleware, routerMiddleware]
if (isDebugEnv) {
  middleware.push(logger)
}

export const store = createStore(
  combineReducers<CombinedReducerState>(
    {
      // @ts-ignore todo @steve please fix this
      router: routerReducer,
      ...rootReducer,
    },
  ),
  composeWithDevTools(
    applyMiddleware(...middleware),
  ),
)

export const history: History = createReduxHistory(store)

sagaMiddleware.run(rootSaga)
